<template>
    <div>
        <div class="seachBox flex">

            <div class="seachList"><span class="name">分类：</span>
<!--                placeholder="请选择"-->
<!--              <a-cascader v-model="seach.a_ksh_module_category_id" :options="seachList.category_list" :fieldNames="fieldNames" placeholder="" />-->
              <a-select v-model="seach.a_ksh_module_category_id" placeholder="请选择" allowClear  style="width: calc(100% - 70px)">
                <a-select-option :value="item.id" v-for="item in seachList.category_list">
                  {{item.name}}
                </a-select-option>
              </a-select>
<!--                <a-select v-model="seach.a_ksh_control_category_id" class="seachs" allowClear @keydown.enter.native="searchKey"  >-->
<!--                    <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.category_list">-->
<!--                        {{item.name}}-->
<!--                    </a-select-option>-->
<!--                </a-select>-->
            </div>
          <div class="seachList"><span class="name">日期：</span>
            <a-range-picker @keydown.enter.native="searchKey" class="seachs" v-model="seach.update_time" :allowClear="false" :showTime="false"
                            format="YYYY-MM-DD"/>
          </div>
          <div class="seachList"><span class="name">状态：</span>
            <!--                placeholder="请选择"-->
            <a-select v-model="seach.status" class="seachs" allowClear @keydown.enter.native="searchKey" >
              <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.status_list">
                {{item.name}}
              </a-select-option>
            </a-select>
          </div>
            <div class="seachList"><span class="name">来源：</span>
<!--                placeholder="请选择"-->
                <a-select v-model="seach.source" class="seachs" allowClear @keydown.enter.native="searchKey" >
                    <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.source_list">
                        {{item.name}}
                    </a-select-option>
                </a-select>
            </div>


            <div class="seachBtnBox">
                <a-button type="primary" class="seachBtn" @click="getList(1)"> 查询</a-button>
                <a-button class="seachBtn" @click="resetSeach()">重置</a-button>
            </div>
        </div>
        <a-button class="top_btn" type="primary" @click="()=>{visible = true; title='添加模块' ;this.editId=''; }"  >
            添加模块
        </a-button>

        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id"
                 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"    :scroll="{ x: 1300 }">
            <span slot="list_order" slot-scope="text, record">
        <a-input   v-model="record.list_order" class="inputs" size="small"/>
            </span>
            <span slot="picture" slot-scope="text, record">
                 <img  :src="record.picture"   style="width:100px;display: block;cursor: pointer">
      </span>


          <span slot="user_display" slot-scope="text, record">
         <a-switch   @click="onChangeProxy(record)"  :checked="text==1?true:false"/>
            </span>

          <span slot="action" slot-scope="text, record">
            <a
                @click="()=>{
                  goToKSH(record)
                }"
            >编辑 <a-divider  type="vertical"/></a>
        <a @click="(record)=>{visible = true;; title='基本信息'; editId=text.id ; }">基本信息 <a-divider  type="vertical"/></a>
             <a-popconfirm
                 title="此操作将永久删除, 是否继续?"
                 ok-text="确定"
                 cancel-text="取消"
                 @confirm="confirm(record)"
                 @cancel="()=>{}">
   <a >删除</a>
  </a-popconfirm>
          </span>
        </a-table>
                <TemplateForm :visible="visible" :title="title" :editId="editId" @changVisible=" () => { this.visible = false;this.editId=''; this.getList(pagination.current)}  "/>
        <IndexContent :visible="visibleIndex" :title="title" :editIds="editIds" @changVisible=" () => { this.editIds='';this.visibleIndex = false; this.getList(pagination.current)}  "/>
        <a-modal  :footer="null"
                  title="查看大图"
                :visible="visibleImg"
                @cancel="()=>{visibleImg=false}"
        >
            <img :src="tableImg" alt="" style="width: 100%;display: block">
        </a-modal>
    </div>
</template>

<script>
    import API from "./api";
    import moment from 'moment';
    import TemplateForm from "./components/templateForm"
    import IndexContent from "./components/indexContent"
    import {changStatus, removeById, orderList, createUrl} from "../../../utils/utils"
    const columns = [
        // {
        //     title: "排序",
        //     dataIndex: "list_order",
        //     key: "list_order",
        //     width: "100px",
        //     scopedSlots: {customRender: "list_order"}
        // },
        {
            title: "缩略图",
            dataIndex: "picture",
            ellipsis: true,
            width: "100px",
            key: "picture",
            scopedSlots: {customRender: "picture"}
        },
        {
          title: "模块名称",
          dataIndex: "name",
          ellipsis: true,
          width: "100px",
          key: "name"
        },

        // {
        //     title: "客户数",
        //     dataIndex: "customer_num",
        //     ellipsis: true,
        //     width: "100px",
        //     key: "customer_num"
        // },
        {
            title: "分类",
            dataIndex: "category_name",
            ellipsis: true,
            width: "100px",
            key: "category_name"
        },

        {
            title: "更新时间",
            dataIndex: "update_time",
            width: "150px",
            ellipsis: true,
            key: "update_time"
        },
      {
        title: "状态",
        key: "status_text",
        width: "10%",
        dataIndex: "status_text",
        scopedSlots: {customRender: "status_text"}
      },
        {
            title: "来源",
            key: "source_text",
            width: "80px",
            dataIndex: "source_text",
            scopedSlots: {customRender: "source_text"}
        },

        {
            title: "操作",
            key: "action",
            width: "150px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: "index",
        data() {
            return {fieldNames: {label: 'name', value: 'id', children: 'children'},
              selectedRowKeys: [],
              urlBase:this.$store.state.urlExper,
                resetSeachdata:true,
                visibleImg:false,
                tableImg:"",
                seach: {
                  a_ksh_control_category_ids: undefined,
                    update_time: [],
                    status:undefined,
                  source:undefined,
                },
                seachList: {
                  category_list: [],
                  status_list: [],
                  source_list:[],
                },
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                data: [],
                columns,
                loading: true,
                visible: false,
                visibleIndex:false,
                title: "",
                editId: null,
                editIds:null,
                jurisdictionId: null,
                visibleJurisdiction: false,
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/ksh/Module"; //设置左侧导航2-2 active
        },
        mounted() {
            this.getList()
        },
        components:{TemplateForm,IndexContent},
        methods: {
          goToKSH(record){
            window.open(createUrl(record.ksh_token),'_blank')
          },
          onChange(row) {
            let Json = {id: row.id, is_order_message: row.is_order_message == 1 ? 2 : 1}
            changStatus(API.service.CHANG_STATUS_MESSAGE, [Json]).then(res => {
              if (res == true) {
                this.getList()
              }
            })

          },
          onChangeProxy(row) {
            let Json = {id: row.id, user_display: row.user_display == 1 ? 2 : 1}
            changStatus(API.service.CHANG_STATUS_PROXY, [Json]).then(res => {
              if (res == true) {
                this.getList()
              }
            })

          },
            searchKey(){
                if(event.keyCode == 13){
                    this.getList(1)
                }
            },
            indexCont(id){
                this.visibleIndex = true
                this.title='首页内容';
                setTimeout(() => { this.editIds= id ; }, 300)
            },
            confirm(row) {
                removeById(API.service.DELE, [row.id]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
            // listOrder() {
            //     let list_orders = []
            //     let sortListOrder = {id: "", list_order: ""}
            //     for (let i = 0; i < this.data.length; i++) {
            //         sortListOrder.id = this.data[i].id
            //         sortListOrder.list_order = this.data[i].list_order
            //         list_orders.push(sortListOrder)
            //         sortListOrder = {}
            //     }
            //     orderList(API.service.CHANG_STATUS, list_orders).then(res => {
            //         if (res == true) {
            //             this.getList()
            //         }
            //     })
            // },
            resetSeach() {
                this.loading = true
                this.seach = { a_ksh_module_category_id: undefined,
                  update_time: [],
                  status:undefined,
                  source:undefined,
                }
                this.resetSeachdata=false
                this.getList(1)
            },
            getList(page) {
                let seachData=JSON.parse(JSON.stringify(this.seach))
                if (seachData.update_time.length > 0&&this.resetSeachdata==true) {
                    seachData.update_time[0] = moment(this.seach.update_time[0]).format('YYYY-MM-DD')
                    seachData.update_time[1] = moment(this.seach.update_time[1]).format('YYYY-MM-DD')
                }else{
                    seachData.update_time=[]
                }
                API.service.GET_LIST({page: page || 1, ...seachData}).then(res => {
                    this.data = res.data.data.list.data
                    this.seachList.status_list = res.data.data.status_list
                    this.seachList.source_list = res.data.data.source_list
                    this.seachList.category_list = res.data.data.category_list

                    this.pagination.total=res.data.data.list.total
                    this.pagination.pageSize=res.data.data.list.per_page
                    this.pagination.current=res.data.data.list.current_page
                    if(!this.resetSeachdata==true)this.seach.update_time=[]
                    this.resetSeachdata=true
                    this.loading = false
                })
            },

          exper(id) {
            let seachData=JSON.parse(JSON.stringify(this.seach))


            if (seachData.update_time.length > 0&&this.resetSeachdata==true) {
              seachData.update_time[0] = moment(this.seach.update_time[0]).format('YYYY-MM-DD')
              seachData.update_time[1] = moment(this.seach.update_time[1]).format('YYYY-MM-DD')
            }else{
              seachData.update_time=[]
            }
            API.service.EXPORT({...seachData,ids:this.selectedRowKeys}).then(res => {
              window.open( `${this.$store.state.urlExper}${res.data.data.substr(1)}`  )
              // this.getList()
              // this.selectedRowKeys = []
            })
          },
          onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
          },

        }
    }
</script>

<style scoped>
    .seachBox .seachList .name{width: 70px!important;}
    .seachBox .seachList .seachs{width: calc(100% - 80px);}
    .seachBox .seachBtnBox{position: static;margin-top: 0;text-align: right;padding-right: 10px;}
    .ant-cascader-picker{width: calc(100% - 70px)}
</style>
